import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      routing: {
        routes: {
          savedcartDetails: {
            paths: ['saved-cart/saved-cart-details/:cartId'],
            paramsMapping: { cartId: 'code' },
          },
        },
      },
    }),
  ],
})
export class SavedCartRoutesModule {}
